module.exports = __webpack_public_path__ + "img/cancel.5c0d5dea.svg";